export default "__VITE_ASSET__CXZUr2El__"